export default class Storage {
  static saveStorage({ key, value }: { key: string; value: string }) {
    localStorage.setItem(key, value);
  }

  static getStorage({ key }: { key: string }): string | null {
    return localStorage.getItem(key);
  }

  static saveUser(value: Record<string, any>) {
    Storage.saveStorage({ key: "user", value: JSON.stringify(value) });
  }

  static getUser(): Record<string, any> | "" {
    const userData = Storage.getStorage({ key: "user" });
    if (userData) {
      return JSON.parse(userData);
    }
    return "";
  }

  static addToUser({ key, value }: { key: string; value: any }) {
    const userData = Storage.getUser();
    if (userData) {
      Storage.saveStorage({
        key: "user",
        value: JSON.stringify({ ...userData, [key]: value }),
      });
    }
  }

  static saveToken(token: string) {
    Storage.saveStorage({ key: "token", value: token });
  }

  static saveExtender(extender: string) {
    Storage.saveStorage({ key: "extender", value: extender });
  }

  static getToken() {
    const token = Storage.getStorage({ key: "token" });
    if (token === undefined || token === "undefined") {
      Storage.removeStorage("token");
      Storage.removeStorage("extender");
      return "";
    }
    return token;
  }

  static getExtender() {
    return Storage.getStorage({ key: "extender" });
  }

  static removeStorage(key: string) {
    localStorage.removeItem(key);
  }

  static removeUser() {
    localStorage.removeItem("user");
  }

  static removeToken() {
    localStorage.removeItem("token");
  }

  static removeExtender() {
    localStorage.removeItem("extender");
  }

  static removePermission() {
    localStorage.removeItem("permission");
  }

  static mergeValue(key: string, value: object) {
    const existingData = Storage.getStorage({ key });
    let newData;
    
    if (existingData) {
      try {
        const parsedData = JSON.parse(existingData);
        if (Array.isArray(parsedData)) {
          newData = [...parsedData, value];
        } else {
          newData = {...parsedData, ...value};
        }
      } catch {
        newData = [existingData, value];
      }
    } else {
      newData = value;
    }
    
    Storage.saveStorage({ key, value: JSON.stringify(newData) });
  }

  static logoutStorage() {
    Storage.removeUser();
    Storage.removeToken();
  }

  static getPermission() {
    const jsPermission = Storage.getStorage({ key: "permission" });
    if (jsPermission) {
      try {
        return JSON.parse(jsPermission);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  static setPermission({ type, value }: { type: string; value: any }) {
    let permission;
    const prevPermission = Storage.getPermission();
    if (!prevPermission) {
      permission = {};
    } else {
      permission = prevPermission;
    }
    permission[type] = value;
    Storage.saveStorage({
      key: "permission",
      value: JSON.stringify(permission),
    });
  }

  static setLanguage(lang: string) {
    localStorage.setItem("LANG", lang);
  }

  static getLanguage() {
    return localStorage.getItem("LANG");
  }

  static clearAll(){
    localStorage.clear();
  }
}
